// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// 🔗  'llevaA' debe coincidir con el nombre de otra sección
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const MODULOS = {
  mensaje: '¿Qué módulo necesitas encontrar?',
  opciones: [
    { boton: '🛒 Comercial',          llevaA: 'comercial'     },
    { boton: '📦 Logística',          llevaA: 'logistica'     },
    { boton: '📒 Contabilidad',       llevaA: 'contabilidad'  },
    { boton: '💰 Cuentas por Cobrar', llevaA: 'cuentasCobrar' },
    { boton: '🏦 Cuentas por Pagar',  llevaA: 'cuentasPagar'  },
    { boton: '📈 Dashboard',          llevaA: 'dashboard'     },
    { boton: '🏭 Producción',         llevaA: 'produccion'    },
  ],
}
